import { render } from "./SetChapter.vue?vue&type=template&id=cf731358&scoped=true"
import script from "./SetChapter.vue?vue&type=script&lang=js"
export * from "./SetChapter.vue?vue&type=script&lang=js"

import "./SetChapter.vue?vue&type=style&index=0&id=cf731358&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-cf731358"

export default script